module.exports = __webpack_public_path__ + "img/空白（居右页码+插图）.bde37e88.jpg";